export const List = () => import("./List.vue");
export const Show = () => import("./Show.vue");
export const Stock = () => import("./Stock.vue");
export const Groups = () => import("./Groups.vue");
export const Barcode = () => import("./Barcode.vue");
export const DayBook = () => import("./DayBook.vue");
export const ChitBill = () => import("./ChitBill.vue");
export const PrepareBill = () => import("./PrepareBill.vue");
export const OfficerBill = () => import("./OfficerBill.vue");
export const MonthlyBill = () => import("./MonthlyBill.vue");
export const ItemRevenue = () => import("./ItemRevenue.vue");
export const GroupLedger = () => import("./GroupLedger.vue");
export const LedgerDetails = () => import("./LedgerDetails.vue");
export const MonthlyLedger = () => import("./MonthlyLedger.vue");
export const MyBillDetails = () => import("./MyBillDetails.vue");
export const ProductionCost = () => import("./ProductionCost.vue");
export const RejectedChitBill = () => import("./RejectedChitBill.vue");
export const PreSanctionDetails = () => import("./PreSanctionDetails.vue");
export const MonthlySummaryBill = () => import("./MonthlySummaryBill.vue");
export const AuditLedgerDetails = () => import("./AuditLedgerDetails.vue");
export const TransanctionDetails = () => import("./TransanctionDetails.vue");
export const MonthlySalePurchase = () => import("./MonthlySalePurchase.vue");
export const ProductionCostDetails = () => import("./ProductionCostDetails.vue");
